export var ModelBackendEnum;
(function (ModelBackendEnum) {
    ModelBackendEnum["LUXONIS"] = "LUXONIS";
    ModelBackendEnum["ULTRALYTICS"] = "ULTRALYTICS";
    ModelBackendEnum["RF_DETR"] = "RF_DETR";
})(ModelBackendEnum || (ModelBackendEnum = {}));
//# sourceMappingURL=model.enums.js.map